import * as React from 'react';
import { addDays, format } from 'date-fns';
import { Calendar as CalendarIcon, ChevronDown } from 'lucide-react';
import { DateRange } from 'react-day-picker';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

type DateRangePickerProps = {
  date: DateRange | undefined;
  onDateChange: (date: DateRange | undefined) => void;
  className?: string;
};

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  date,
  onDateChange,
  className,
}) => {
  return (
    <div className={cn('grid gap-2', className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id='date'
            className={cn(
              'border h-[44px] md:h-auto border-muted-foreground md:border-none px-4 bg-transparent justify-start text-left font-normal hover:bg-transparent focus:bg-transparent w-full',
              !date && 'text-muted-foreground'
            )}
          >
            {date?.from ? (
              date.to ? (
                <div className='text-[#979797] font-medium w-full justify-between flex items-center'>
                  {format(date.from, 'LLL dd')} - {format(date.to, 'LLL dd')}
                  <ChevronDown className='ml-2 h-6 w-6 text-[#979797]' />
                </div>
              ) : (
                <div className='text-[#979797] font-medium w-full justify-between flex items-center'>
                  {format(date.from, 'LLL dd, y')}
                  <ChevronDown className='ml-2 h-6 w-6 text-[#979797]' />
                </div>
              )
            ) : (
              <>
                <span className='text-[#979797] w-full justify-between font-medium'>
                  Date
                </span>
                <ChevronDown className='ml-2 h-6 w-6 text-[#979797]' />
              </>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className='w-auto p-0' align='start'>
          <Calendar
            initialFocus
            mode='range'
            defaultMonth={date?.from}
            selected={date}
            onSelect={onDateChange}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
